module.exports = __webpack_public_path__ + "static/media/route.4dd1cd3a.svg";